require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-comma-quibbling.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-comma-quibbling");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-comma-quibbling!./.cache/json/coding-interview-prep-rosetta-code-comma-quibbling.json
// module id = 1846
// module chunks = 231608221292675